(function () {
	function slideUp(element, duration) {
		duration = duration || 300;
		element.style.height = element.offsetHeight + "px";
		element.offsetHeight;
		element.style.overflow = "hidden";
		element.style.transitionProperty = "height, margin, padding";
		element.style.transitionDuration = duration + "ms";
		element.style.height = "0";
		element.style.paddingTop = "0";
		element.style.paddingBottom = "0";
		element.style.marginTop = "0";
		element.style.marginBottom = "0";
		window.setTimeout(function () {
			element.style.display = "none";
			element.style.removeProperty("height");
			element.style.removeProperty("padding-top");
			element.style.removeProperty("padding-bottom");
			element.style.removeProperty("margin-top");
			element.style.removeProperty("margin-bottom");
			element.style.removeProperty("overflow");
			element.style.removeProperty("transition-duration");
			element.style.removeProperty("transition-property");
		}, duration);
	}

	function slideDown(element, duration) {
		duration = duration || 300;
		element.style.removeProperty("display");
		let displayValue = window.getComputedStyle(element).display;
		if (displayValue === "none") displayValue = "block";
		element.style.display = displayValue;
		const height = element.offsetHeight;
		element.style.overflow = "hidden";
		element.style.height = "0";
		element.style.paddingTop = "0";
		element.style.paddingBottom = "0";
		element.style.marginTop = "0";
		element.style.marginBottom = "0";
		element.offsetHeight;
		element.style.transitionProperty = "height, margin, padding";
		element.style.transitionDuration = duration + "ms";
		element.style.height = height + "px";
		element.style.removeProperty("padding-top");
		element.style.removeProperty("padding-bottom");
		element.style.removeProperty("margin-top");
		element.style.removeProperty("margin-bottom");
		window.setTimeout(function () {
			element.style.removeProperty("height");
			element.style.removeProperty("overflow");
			element.style.removeProperty("transition-duration");
			element.style.removeProperty("transition-property");
		}, duration);
	}

	const toggleCollapsible = (currentSummary) => {
		const parentItem = currentSummary.closest(".collapsible-content-item");
		const section = currentSummary.closest(".collapsible-content-box");

		const isCurrentlyActive = parentItem.classList.contains("active");

		if (section) {
			section.querySelectorAll(".collapsible-content-item.active").forEach(function (activeItem) {
				activeItem.classList.remove("active");
				activeItem.querySelectorAll(".collapsible-content-block__description").forEach(function (desc) {
					slideUp(desc, 300);
				});
			});
		}

		if (!isCurrentlyActive) {
			parentItem.classList.add("active");
			const next = currentSummary.nextElementSibling;
			if (next && next.classList.contains("collapsible-content-block__description")) {
				slideDown(next, 300);
			}
		}
	};

	const initCollapsibleContent = () => {
		document.querySelectorAll(".collapsible-content-summery").forEach(function (oldEl) {
			oldEl.setAttribute("tabindex", "0");
			const el = oldEl.cloneNode(true);
			oldEl.parentNode.replaceChild(el, oldEl);

			el.addEventListener("click", function () {
				toggleCollapsible(el);
			});
			el.addEventListener("keydown", function (event) {
				if (event.key === "Enter" || event.keyCode === 13) {
					event.preventDefault();
					toggleCollapsible(el);
				}
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	document.addEventListener("DOMContentLoaded", function () {
		initCollapsibleContent();
	});
})();
